import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Pagination from 'react-paginate';
import RightIcon from '@material-ui/icons/ChevronRight';
import LeftIcon from '@material-ui/icons/ChevronLeft';
import ButtonBase from '@material-ui/core/ButtonBase';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  pageInfo: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  pagination: {
    marginLeft: 'auto',
    display: 'flex',
    '& a': {
      border: `1px solid ${theme.palette.common.lightBorder}`,
      marginLeft: -1,
      padding: '6px 12px',
      textAlign: 'center',
      display: 'block',
      backgroundColor: theme.palette.common.white,
    },
    '& li:first-child a': {
      padding: 0,
      borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
    },
    '& li:first-child button': {
      padding: '3px 4px 2px 4px',
    },
    '& li:last-child a': {
      padding: 0,
      borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
    },
    '& li:last-child button': {
      padding: '3px 4px 2px 4px',
    },
    '& li.active a': {
      backgroundColor: theme.palette.common.primary,
      borderColor: theme.palette.common.primary,
      color: theme.palette.common.white,
    },
  },
  paginationList: {},
});

const TablePagination = (props) => {
  const {
    classes,
    className,
    dataCount,
    onPageChange,
    rowsPerPage,
    currentPage,
    pageCount,
  } = props;

  const fromRecord = currentPage * rowsPerPage + 1;
  const toRecord = currentPage * rowsPerPage + rowsPerPage;

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.pageInfo}>
        Viewing{' '}
        <b>
          {fromRecord}-{toRecord > dataCount ? dataCount : toRecord}
        </b>{' '}
        of <b>{dataCount}</b>
      </div>
      <Pagination
        containerClassName={classes.pagination}
        previousLabel={
          <ButtonBase>
            <LeftIcon />
          </ButtonBase>
        }
        nextLabel={
          <ButtonBase>
            <RightIcon />
          </ButtonBase>
        }
        breakLabel={null}
        pageCount={pageCount}
        marginPagesDisplayed={0}
        pageRangeDisplayed={4}
        onPageChange={onPageChange}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        forcePage={currentPage}
      />
    </div>
  );
};

TablePagination.propTypes = {
  classes: PropTypes.object.isRequired,
  dataCount: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  className: PropTypes.string,
};

export default withStyles(styles)(TablePagination);
